import { Product, FpoMarketStock, GroupedFpo } from "../types/public.types";

/**
 * Deduplicates a list of products by their unique _id.
 */
export const deduplicateProducts = (products: Product[]): Product[] => {
  return products.filter(
    (item, index, self) => index === self.findIndex((t) => t._id === item._id)
  );
};

/**
 * Groups FPO market stock listings by FPO User ID or fallback key.
 */
export const groupFpoStocks = (stocks: FpoMarketStock[]): GroupedFpo[] => {
  const groupedFpos: GroupedFpo[] = [];
  const groups: Record<string, FpoMarketStock[]> = {};

  stocks.forEach((stock) => {
    const dist = stock.district;
    const distName = typeof dist === "object" ? dist?.name : dist;
    const key =
      stock.fpoUser && typeof stock.fpoUser === "object"
        ? (stock.fpoUser as any)._id
        : stock.fpoUser || `${stock.fpoName}-${distName}`;

    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(stock);
  });

  Object.keys(groups).forEach((key) => {
    const group = groups[key];
    const latest = group[0];
    const allActivities = Array.from(
      new Set(group.flatMap((s) => s.activities || []))
    ).filter(Boolean);
    const categories = Array.from(
      new Set(group.map((s) => s.category?.name).filter(Boolean))
    );

    groupedFpos.push({
      fpoUserId: key,
      slug: latest.fpoUser?.slug || key,
      fpoName: latest.fpoName,
      taluk: latest.fpoUser?.taluk || latest.taluk,
      district: latest.fpoUser?.district || latest.district,
      address: latest.fpoUser?.address,
      scheme: latest.scheme,
      activities: allActivities,
      contactPerson: latest.contactPerson,
      mobileNumber: latest.fpoUser?.phoneNumber || latest.mobileNumber,
      gstNumber: latest.gstNumber || latest.fpoUser?.gstNumber,
      categories,
      entries: group,
      createdAt: latest.createdAt,
    });
  });

  return groupedFpos;
};
